import Navbar from 'components/Navbar'
import { ReactComponent as CrossIcon } from 'icons/cross-20.svg'
import React from 'react'

import { SidebarLoadingPage } from './SidebarLoadingPage'

const CrossButton = () => <Navbar.Button icon={CrossIcon} />

export const ArtboardDetailsLoadingPage = () => {
  return <SidebarLoadingPage logo={CrossButton} footer={null} />
}
